/** Local first-of-month keys for Snapshot drafts (this month or next). */

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

export function currentSnapshotMonth(now = new Date()): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-01`;
}

export function nextSnapshotMonth(month = currentSnapshotMonth()): string {
  const year = Number(month.slice(0, 4));
  const mon = Number(month.slice(5, 7));
  if (mon === 12) return `${year + 1}-01-01`;
  return `${year}-${pad(mon + 1)}-01`;
}

export function snapshotMonthLabel(iso: string): string {
  const year = Number(iso.slice(0, 4));
  const mon = Number(iso.slice(5, 7));
  if (!year || !mon) return iso;
  return new Date(year, mon - 1, 1).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });
}

export function isAllowedSnapshotMonth(iso: string, now = new Date()): boolean {
  const current = currentSnapshotMonth(now);
  return iso === current || iso === nextSnapshotMonth(current);
}

export function parseSnapshotMonthParam(
  raw: string | null | undefined,
  now = new Date(),
): string | undefined {
  if (!raw) return undefined;
  const text = raw.trim();
  const iso = text.length >= 10 ? text.slice(0, 10) : `${text}-01`;
  return isAllowedSnapshotMonth(iso, now) ? iso : undefined;
}
